import axios from 'axios';

for (const method of ['request', 'delete', 'get', 'head', 'options', 'post', 'put', 'patch']) {
    axios['$' + method] = function() {
        return this[method].apply(this, arguments).then(res => res && res.data);
    };
}

export const state = () => ({
    pinnedQuestions: []
});

export const getters = {
    pinnedQuestions: state => state.pinnedQuestions
};

export const mutations = {
    SET_PINNED_QUESTIONS(state, pinnedQuestions) {
        state.pinnedQuestions = pinnedQuestions;
    },

    CREATE_PINNED_QUESTION(state, pinnedQuestion) {
        state.pinnedQuestions = [...state.pinnedQuestions, pinnedQuestion];
    },

    REMOVE_PINNED_QUESTION(state, id) {
        state.pinnedQuestions = state.pinnedQuestions.filter(pinnedQuestion => pinnedQuestion.id !== id);
    },

    EDIT_PINNED_QUESTION(state, { id, text}) {
        const pinnedQuestion = state.pinnedQuestions.find(pinnedQuestion => pinnedQuestion.id === id);
        pinnedQuestion.text = text;
    }
};

export const actions = {
    createSession(vuexContext, feedHash) {
        return axios.$post('/v1/helper/chats/', feedHash);
    },

    async sendMessage(vuexContext, { id, message }) {
        return axios.$post(`/v1/helper/chats/${id}/messages`, { question: message });
    },

    async loadPinnedQuestions({ commit }) {
        const res = await axios.$get('/v1/helper/pinned_questions');
        commit('SET_PINNED_QUESTIONS', res);
        return res;
    },

    async createPinnedQuestion({ commit }, question) {
        const res = await axios.$post('/v1/helper/pinned_questions', { text: question });
        commit('CREATE_PINNED_QUESTION', res);
        return res;
    },

    async updatePinnedQuestion({ commit }, {text, id}) {
        const res = await axios.$put(`/v1/helper/pinned_questions/${id}`, { text});
        commit('EDIT_PINNED_QUESTION', res);
        return res;
    },

    async removePinnedQuestion({ commit }, id) {
        commit('REMOVE_PINNED_QUESTION', id);
        const res = await axios.$delete(`/v1/helper/pinned_questions/${id}`);

        return res;
    },

    async recoverMessage(vuexContext, { sessionId, id }) {
        return axios.$post(`/v1/helper/chats/${sessionId}/messages/${id}/recover`);
    },

    async getMcpApp(vuexContext, uri) {
        return axios.$get('/v1/mcp_app', { params: { uri } });
    },

    async callMcpAppTool(vuexContext, { name, arguments: args }) {
        return axios.$post('/v1/mcp_app/call_tool', { name, arguments: args });
    },

    async upVoteMessage(vuexContext, { sessionId, id }) {
        return axios.$post(`/v1/helper/chats/${sessionId}/messages/${id}/up_vote`);
    },

    async downVoteMessage(vuexContext, { sessionId, id, reason = null }) {
        let params = {};
        if (reason) {
            params.reason = reason;
        }

        return axios.$post(`/v1/helper/chats/${sessionId}/messages/${id}/down_vote`, params);
    }
};

export default { state, getters, mutations, actions };
